export class SignInRequest {
  constructor(public userName: string, public password: string) {}
}
